export const PERMISSIONS = {
  HR: {
    EMPLOYEE: {
      CREATE: "employee.create", //done
      VIEW: "employee.view", //done
      EDIT: "employee.edit", //done
      DELETE: "employee.delete", //done,

      LIST: 'employees.list', // done
      PAYROLL: 'payroll.management', // done
      SALARY: 'employee.salaries', // done
      ADVANCE: 'employee.advance', // done
      RUN_HISTORY: 'payroll.run_history', // done

      DOCUMENTS: {
        UPLOAD: "employee.documents.upload",  // Not required
        VIEW: "employee.documents.view", // Not required
        DELETE: "employee.documents.delete", // Not required
      },

      EXPERIENCE: {
        ADD: "employee.experience.add", // Not required
        VIEW: "employee.experience.view", // Not required
        DELETE: "employee.experience.delete", // Not required
      },

      APPOINTMENT: {
        GENERATE: "employee.appointment.generate", // done
        DOWNLOAD: "employee.appointment.download", // done
      },
    },

    LEAVE: {
      APPLY: "leave.apply", // done
      ADMIN_APPLY: 'leave.apply_admin', // done
      CANCEL: "leave.cancel", // done
      VIEW_SELF: "leave.view_self",
      VIEW_TEAM: "leave.view_team",
      APPROVE: "leave.approve",
      CONFIGURE: "leave.configure",
    },
  },

  PAYROLL: {
    GENERATE: "payroll.generate", // done
    EDIT: "payroll.edit",
    LOCK: "payroll.lock",
    UNLOCK: "payroll.unlock",

    VIEW_SELF: "payslip.view_self",
    VIEW_ALL: "payslip.view_all",
    DOWNLOAD: "payslip.download",

    SALARY: {
      ADJUSTMENT_UPDATE: "salary.adjustment.update",
    },
  },

  FINANCE: {
    INVOICE: {
      CREATE: "invoice.create", // done
      VIEW: "invoice.view", // done
      EDIT: "invoice.edit", // done
      DELETE: "invoice.delete", // done
      DOWNLOAD: "invoice.download",


      CLIENT_MANAGE: 'client.management', // done
      CLIENT_LIST: 'client.list', // done
      CLIENT_ADD: 'client.add', // done
      VENDOR_MANAGEMENT: 'vendor.management', // done
      VENDOR_ADD: 'vendor.add', // done
      VENDOR_DETAILS: 'vendor.details', // done
      VENDOR_EDIT: 'vendor.edit', // done
      INVOICE_MANAGEMENT: 'invoice.management',
      PAYMENT_MANAGEMENT: 'payment.management',
      PAYMENT_DETAILS: 'payment.details'
    },
    RECEIPT: {
      CREATE: "receipt.create",
      VIEW: "receipt.view",
      DOWNLOAD: "receipt.download",
    },
    PAYMENT_SUMMARY: "payment.summary.view",
  },

  EXPENSES: {
    EXPENSE: {
      SUBMIT: "expense.submit", // done
      ADMIN_SUBMIT: 'expense.admin_submit', // done
      VIEW_SELF: "expense.view_self", // done
      APPROVE: "expense.approve", // done
      VIEW_ALL: "expense.view_all", // done

      COMPANY_EXPENSE_ADD: 'company_expense.add',
      COMPANY_EXPENSE_ADD: 'company_expense.view',
      COMPANY_EXPENSE_SUMMARY: 'report.expense_summary' // done
    },
    COMPANY_EXPENSE: {
      ADD: "company_expense.add",
      EDIT: "company_expense.edit",
      DELETE: "company_expense.delete",
      VIEW: "company_expense.view",
    },
  },

  REPORTS: {
    PAYROLL_SUMMARY: "report.payroll_summary",
    ACCOUNT_SUMMARY: "report.account_summary",
    LEAVE_SUMMARY: "report.leave_summary", // done
    EXPENSE_SUMMARY: "report.expense_summary",
    INVOICE_SUMMARY: "report.invoice_summary", // done
  },

  DOCUMENTS: {
    UPLOAD: "document.upload",
    VIEW: "document.view",
    DELETE: "document.delete",
    DOWNLOAD: "document.download",
  },

  SYSTEM: {
    SETTINGS: {
      VIEW: "system.settings.view",
      UPDATE: "system.settings.update",
    },
    ROLE: {
      VIEW: 'role.view',
      CREATE: "role.create", // done
      EDIT: "role.edit", // done
      DELETE: "role.delete", // cannot be deleted
    },
    PERMISSION_ASSIGN: "permission.assign", // done

    USER: {
      ROLE_ASSIGN: "user.role.assign",
      PERMISSION_OVERRIDE: "user.permission.override",
      CREATE: 'user.create', // done
      VIEW: 'user.view', // done
      EDIT: 'user.edit', // done
      DELETE: 'user.delete'
    },
    EMPLOYEE_SELF: {
      EMPLOYEE: 'profile.view'
    },
    MASTER: {
      MANAGE_MASTER: 'master.manage', // done
      COMPANY_MASTER: 'master.company', // done
      LOOKUP_MASTER: 'master.lookup', // done
      COUNTRY_MASTER: 'master.country', // done
    }
  },
};
